import { CrudState } from "@/store/Crud/State";
export class State extends CrudState {
  furtherEducationsList: Array<any> = [];
}
